import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { Component } from '@angular/core';
import { BaseModalComponent } from '../../../widgets/entry-components/modal/components/base/base-modal.component';
import { ModalController } from '@ionic/angular';
import { FormGenModel } from '../../../shared/models/form-gen.model';

export const GROUPFORMGEN: FormGenModel[] = [
  { label: 'NAME', value: 'name', required: true, id: 'group-name' }
];

export function getGroupForm(): FormGroup {
  return new FormGroup({
    id: new FormControl(),
    identifier: new FormArray([new FormGroup({
      value: new FormControl('')
    })]),
    managingEntity: new FormGroup({
      reference: new FormControl(),
      display: new FormControl()
    }),
    name: new FormControl('', Validators.required),
    active: new FormControl(true),
    member: new FormArray([]),
  });
}

@Component({
  selector: 'inc-group-add-modal',
  templateUrl: './../../../widgets/entry-components/modal/components/base/base-modal.component.html',
  styleUrls: ['./group-add.component.scss'],
})
export class GroupAddModalComponent extends BaseModalComponent {
  title = 'ADD_CARETEAM';
  formGenList = GROUPFORMGEN;

  constructor(modalController: ModalController) {
    super(modalController);
    this.reset(getGroupForm());
  }

  save() {
    this.baseSave(this.form.value);
  }

}
